import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { type OpportunityType } from '@/api/opportunity';
import { type MarkerDataType } from '@/components/Flare/annotation';
import TooltipRow from '@/components/Flare/guides/TooltipRow';
import { Tooltip, TooltipContent, TooltipTitle, TooltipTrigger } from '@/components/Tooltip';
import { MonthDateYearFormat } from '@/constants/formats';
import { formatDate } from '@/helper/dateHelper';
import { numberFormat } from '@/helper/numberFormatter';

type Props = {
  data: MarkerDataType;
  opportunity?: OpportunityType;
};

const OpportunityDetailMarkerTooltip = ({ data, opportunity }: Props) => {
  return (
    <Tooltip>
      <TooltipTrigger render={<span>{data.label}</span>} />
      <TooltipContent side="bottom" sideOffset={20} className="flex-col items-start">
        <TooltipTitle>
          <Trans>Opportunity</Trans>
        </TooltipTitle>
        <table className="min-w-50">
          <tbody>
            <TooltipRow
              name={t`Opened`}
              value={formatDate(opportunity?.openDate, MonthDateYearFormat, { isUTC: true })}
            />
            <TooltipRow
              name={t`Closed`}
              value={formatDate(opportunity?.closeDate, MonthDateYearFormat, { isUTC: true })}
            />
            <TooltipRow
              name={t`Amount`}
              value={numberFormat(opportunity?.amount, {
                isCurrency: true,
                precision: 0,
              })}
            />
          </tbody>
        </table>
      </TooltipContent>
    </Tooltip>
  );
};

export default OpportunityDetailMarkerTooltip;
